// "use client"

import * as React from "react"
import { format, parse } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "../../lib/utils"
import { Button } from "../../component/ui/button"
import { Calendar } from "../../component/ui/calender"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../component/ui/popover"

export function DatePicker({ className, input, meta,disabled }) {
  const [date, setDate] = React.useState(() => {
    if (input?.value) {
      // Attempt to parse `dd.MM.yyyy` format first
      let parsedDate = parse(input.value, "dd.MM.yyyy", new Date());
  
       // If `dd.MM.yyyy` parsing fails, try `dd-MM-yyyy` format
  if (isNaN(parsedDate)) {
    parsedDate = parse(input.value, "dd-MM-yyyy", new Date());
  }

      // If `dd.MM.yyyy` parsing fails, try the standard date string
      if (isNaN(parsedDate)) {
        parsedDate = new Date(input.value);
      }
  
      // Check if the parsed date is valid
      if (!isNaN(parsedDate)) {
        return parsedDate;
      }
    }
  
    // Default to null if invalid or not provided
    return null;
  });
  
  

  // Update the form value when the date is selected
  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    input.onChange(selectedDate);
  };

  const currentDate = new Date();
  const year = new Date(currentDate).getFullYear();

  return (
    <div>
      <Popover>
        <PopoverTrigger asChild>
          <Button
          disabled={disabled}
            variant={"outline"}
            className={cn(
              "w-[280px] justify-start text-left font-normal border-[#3a5dd1] h-10",
              !date && "text-muted-foreground",
              className // Accept custom class from parent component
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? format(date, "PPP") : <span>Pick a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            captionLayout="dropdown-buttons"
            fromYear={1900}
            toYear={year}
            mode="single"
            selected={date}
            onSelect={handleDateChange}
            disabled={(date) => date > new Date()}
            initialFocus
            className="bg-white border-[#3a5dd1] border rounded-lg"
          />
        </PopoverContent>
      </Popover>

      {/* Display error message if validation fails */}
      {meta?.touched && meta.error && (
        <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
      )}
    </div>
  )
}
